// extracted by mini-css-extract-plugin
export default {"Item":"Selector-module__Item__Kpw4nut"};